const cartoApiKey = process.env.REACT_APP_CARTO_APIKEY;

export const CARTO_TILE_URL = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png${
  cartoApiKey ? `?key=${cartoApiKey}` : ""
}`;

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://carto.com/attributions">CartoDB</a>';
